<script lang="ts">
  import { t } from '$core/i18n';
  import { Modal } from '$ui/primitives/Modal';
  import { Button } from '$ui/primitives/Button';

  let {
    outboxCount,
    outboxBytes,
    quarantineCount,
    quarantineBytes,
    busy = false,
    onExport,
    onLeave,
    onCancel
  }: {
    outboxCount: number;
    outboxBytes: number;
    quarantineCount: number;
    quarantineBytes: number;
    busy?: boolean;
    onExport: () => void;
    onLeave: () => void;
    onCancel: () => void;
  } = $props();

  let totalCount = $derived(outboxCount + quarantineCount);
  let totalBytes = $derived(outboxBytes + quarantineBytes);

  function formatBytes(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }

  let open = $state(true);
</script>

<Modal
  bind:open
  title={t('auth.pendingQueue.title')}
  size="sm"
  onclose={onCancel}
>
  <p class="body">
    {t('auth.pendingQueue.body', {
      n: String(totalCount),
      bytes: formatBytes(totalBytes)
    })}
  </p>

  {#snippet footer()}
    <Button variant="outline" disabled={busy} onclick={onCancel}>
      {t('auth.pendingQueue.cancel')}
    </Button>
    <Button variant="outline" disabled={busy} onclick={onLeave}>
      {t('auth.pendingQueue.leave')}
    </Button>
    <Button variant="filled" disabled={busy} onclick={onExport}>
      {t('auth.pendingQueue.export')}
    </Button>
  {/snippet}
</Modal>

<style>
  .body {
    margin: 0;
    color: var(--color-text-secondary);
    font-size: var(--text-body);
    line-height: var(--text-body-lh);
    text-wrap: pretty;
  }
</style>